import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <circle key='0' fill='#00B90F' className='st0' cx='12' cy='12' r='11' />,
    <path
      key='1'
      fill='#000000'
      d='M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0z M12,2c5.5,0,10,4.5,10,10
	c0,5.5-4.5,10-10,10C6.5,22,2,17.5,2,12C2,6.5,6.5,2,12,2z'
    />,
  ],
  'TransportConditionSpeed'
);

const TransportCircleIcon = function (props) {
  return (
    <SvgIcon
      sx={{
        circle: {
          fill: props.color,
        },
      }}
      {...props}
    />
  );
};

export default memo(TransportCircleIcon);
